import React from 'react';
import {
  Box, Typography, Button, TextField, IconButton, List,
  MenuItem, FormControl, InputLabel, Select, Divider, Chip,
  Tabs, Tab, Switch, Slider, ToggleButton, ToggleButtonGroup,
  CircularProgress, FormControlLabel, Checkbox, Dialog,
  DialogTitle, DialogContent, DialogActions, Paper,
  Accordion, AccordionSummary, AccordionDetails,
} from '@mui/material';
import {
  Add as AddIcon, Delete as DeleteIcon, Edit as EditIcon,
  CallSplit as CallSplitIcon, Cancel as CancelIcon,
  CheckCircle as CheckCircleIcon, Check as CheckMarkIcon,
  Clear as CloseMarkIcon, Image as ImageIcon, TextFields as TextIcon,
  Title as TitleIcon, VideoLibrary as VideoIcon,
  SmartButton as ButtonIcon, CloudUpload as UploadIcon,
  FormatListBulleted as ListIcon, Star as StarIcon,
  Info as InfoIcon, Warning as WarningIcon, Verified as VerifiedIcon,
  ShoppingCart as ShoppingCartIcon, FileCopy as DuplicateIcon,
  ExpandMore as ExpandMoreIcon, ViewModule as TemplateIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import { getPreset, getPresetFontFamilies } from '../../../../textStyle.js';
import { getSuggestedTextColors } from '../../../../utils/offerColorUtils';
import { ELEMENT_TYPES, TEMPLATE_TYPE_OPTIONS } from '../../../../utils/offerElementTypes';
import { LAYOUT_CONFIGS } from '../../../../utils/offerLayoutConfigs';
import { LAYOUT_TYPES } from '../../../../utils/offerElementTypes';
import S3FileUpload from '../../../S3FileUpload';
import SimplePresetSelector from '../../../SimplePresetSelector';
import ButtonPresetSelector from '../../../ButtonPresetSelector';
import ComparisonTablePresetSelector from '../../../ComparisonTablePresetSelector';
import {
  BRANDS_EDITOR_RIGHT_PANEL_WIDTH, BRANDS_EDITOR_SAVED_COL_WIDTH,
  BRANDS_PAGE_MAX_HEIGHT, BRANDS_REF_DEVICE_WIDTH, BRANDS_REF_DEVICE_HEIGHT,
  SETUPS_REF_DEVICE_WIDTH, SETUPS_REF_DEVICE_HEIGHT,
} from '../../../../utils/offerDeviceConstants';
import { useOfferBuilder } from '../../OfferBuilderContext';

const ContentTab = () => {
  const {
      isMobile, isBrandsPage, templatesOnly, customElementsOnly,
      paginationEnabled, isEditingMode, forceRender,
      selectedElement, selectedElementContext, selectedSubElement,
      setSelectedElement, setSelectedElementContext, setSelectedSubElement,
      tabValue, setTabValue, rightPanelOpen, setRightPanelOpen,
      elements, pages, currentPageIndex, pageSettings,
      updateElement, addElement, moveToNewPage,
      handleImageUpload, handleThumbnailUpload, handleMediaUploadForElement,
      contentTabTempValue, setContentTabTempValue,
      buttonContentTabTempValue, setButtonContentTabTempValue,
      buttonUrlTabTempValue, setButtonUrlTabTempValue,
      saveContentTabEdit, cancelContentTabEdit, handleContentTabKeyPress,
      saveButtonContentTabEdit, cancelButtonContentTabEdit, handleButtonContentTabKeyPress,
      saveButtonUrlTabEdit, cancelButtonUrlTabEdit, handleButtonUrlTabKeyPress,
      listItemTextValues, setListItemTextValues,
      localRatingText, setLocalRatingText,
      renameElementId, setRenameElementId, renameElementValue, setRenameElementValue,
      getCurrentFontFamily, getInlineBackgroundColors, getInlineTextColors,
      savedOfferElements, filteredSavedElements, setFilteredSavedElements,
      loadSavedOfferElements, loadSavedElement, deleteSavedElement, editSavedElement,
      selectedBrand, selectedOffer, brands, offers, setSelectedBrand, setSelectedOffer, loadOffersForBrand,
      setShowStatusAlert, setStatusMessage, setStatusTitle,
      showConfirmDialog, setShowConfirmDialog, confirmDialogTitle, confirmDialogMessage,
      confirmAction, setConfirmAction, setConfirmDialogTitle, setConfirmDialogMessage,
      showRenameDialog, setShowRenameDialog,
      showLayoutSelector, setShowLayoutSelector, targetZone, setTargetZone,
      showSaveElementDialog, setShowSaveElementDialog, isUpdatingElement, setIsUpdatingElement,
      currentElementName, setCurrentElementName, selectedSavedElementId, setSelectedSavedElementId,
      setSaveType, saveType, saveCurrentElement,
      showLoadTemplateAlert, setShowLoadTemplateAlert, loadTemplateError,
      showReplaceConfirm, setShowReplaceConfirm, pendingTemplateData, loadReplaceTemplate,
      showStatusAlert, statusMessage, statusTitle,
      showPromptDialog, setShowPromptDialog, promptDialogTitle, promptDialogMessage,
      promptDialogValue, setPromptDialogValue, promptAction, setPromptAction,
      showSaveDialog, setShowSaveDialog, saveTemplate,
      showTemplatesList, setShowTemplatesList, templates, loadTemplate, deleteTemplate,
      setOffers, setForceRender,
      imageUploading, uploadingElementId, savedTemplates, setSavedTemplates,
      preBuiltTemplates, loadPreBuiltTemplate, currentTemplateId, setCurrentTemplateId,
      templateName, setTemplateName, templateType, setTemplateType,
      templateSubtype, setTemplateSubtype, groupTemplatesByType, addLayout,
      showBrandOfferAlert, setShowBrandOfferAlert, renameSavedElement,
      setCurrentPageIndex, setElements, setNextPageId, setPageSettings,
      setPages, setPaginationEnabled, setPendingTemplateData,
    } = useOfferBuilder();

  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom>
        📝 Content Settings
      </Typography>
      {selectedElement.type === ELEMENT_TYPES.FAQ_ACCORDION && (
        <Box>
          <TextField
            fullWidth
            label="FAQ Title"
            value={selectedElement.title}
            onChange={e => updateElement(selectedElement.id, { title: e.target.value })}
            sx={{ mb: 2 }}
          />
    
          {/* Icon Customization */}
          <Box sx={{ mb: 1, p: 1, border: '1px solid #eee', borderRadius: 1, backgroundColor: '#f9f9f9' }}>
            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Icon Settings
            </Typography>
    
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Icon Type</InputLabel>
              <Select
                value={selectedElement.iconType || 'plusMinus'}
                onChange={e => updateElement(selectedElement.id, { iconType: e.target.value })}
                label="Icon Type"
              >
                <MenuItem value="plusMinus">Plus/Minus</MenuItem>
                <MenuItem value="expandMore">Expand More/Less</MenuItem>
                <MenuItem value="arrow">Arrow Up/Down</MenuItem>
                <MenuItem value="arrowDrop">Arrow Drop</MenuItem>
              </Select>
            </FormControl>
    
            <TextField
              fullWidth
              label="Icon Color"
              value={selectedElement.iconColor || '#36C3D6'}
              onChange={e => updateElement(selectedElement.id, { iconColor: e.target.value })}
              sx={{ mb: 2 }}
              inputProps={{ type: 'color' }}
            />
    
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Icon Size</InputLabel>
              <Select
                value={selectedElement.iconSize || 'large'}
                onChange={e => updateElement(selectedElement.id, { iconSize: e.target.value })}
                label="Icon Size"
              >
                <MenuItem value="small">Small</MenuItem>
                <MenuItem value="medium">Medium</MenuItem>
                <MenuItem value="large">Large</MenuItem>
              </Select>
            </FormControl>
    
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedElement.showIcon !== false}
                  onChange={e => updateElement(selectedElement.id, { showIcon: e.target.checked })}
                />
              }
              label="Show expand/collapse icon"
            />
          </Box>
    
          {/* Layout & Alignment */}
          <Box sx={{ mb: 2, p: 2, border: '1px solid #eee', borderRadius: 1, backgroundColor: '#f9f9f9' }}>
            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Layout & Alignment
            </Typography>
    
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Text Alignment</InputLabel>
              <Select
                value={selectedElement.textAlign || 'left'}
                onChange={e => updateElement(selectedElement.id, { textAlign: e.target.value })}
                label="Text Alignment"
              >
                <MenuItem value="left">Left</MenuItem>
                <MenuItem value="center">Center</MenuItem>
                <MenuItem value="right">Right</MenuItem>
              </Select>
            </FormControl>
    
            <TextField
              fullWidth
              label="Item Spacing"
              value={selectedElement.itemSpacing || '12px'}
              onChange={e => updateElement(selectedElement.id, { itemSpacing: e.target.value })}
              sx={{ mb: 2 }}
              placeholder="e.g., 12px, 1rem"
            />
    
            <TextField
              fullWidth
              label="Border Radius"
              value={selectedElement.itemBorderRadius || '4px'}
              onChange={e => updateElement(selectedElement.id, { itemBorderRadius: e.target.value })}
              sx={{ mb: 2 }}
              placeholder="e.g., 4px, 8px, 12px"
            />
    
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedElement.showDivider !== false}
                  onChange={e => updateElement(selectedElement.id, { showDivider: e.target.checked })}
                />
              }
              label="Show divider lines"
            />
    
            {selectedElement.showDivider !== false && (
              <TextField
                fullWidth
                label="Divider Color"
                value={selectedElement.dividerColor || '#C1A7F1'}
                onChange={e => updateElement(selectedElement.id, { dividerColor: e.target.value })}
                sx={{ mt: 2 }}
                inputProps={{ type: 'color' }}
              />
            )}
          </Box>
    
          {/* Colors */}
          <Box sx={{ mb: 2, p: 2, border: '1px solid #eee', borderRadius: 1, backgroundColor: '#f9f9f9' }}>
            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Colors
            </Typography>
    
            <TextField
              fullWidth
              label="Container Background"
              value={selectedElement.containerBackgroundColor || 'transparent'}
              onChange={e => updateElement(selectedElement.id, { containerBackgroundColor: e.target.value })}
              sx={{ mb: 2 }}
              inputProps={{ type: 'color' }}
            />
    
            <TextField
              fullWidth
              label="Question Background"
              value={selectedElement.questionBackgroundColor || 'transparent'}
              onChange={e => updateElement(selectedElement.id, { questionBackgroundColor: e.target.value })}
              sx={{ mb: 2 }}
              inputProps={{ type: 'color' }}
            />
    
            <TextField
              fullWidth
              label="Answer Background"
              value={selectedElement.answerBackgroundColor || 'rgba(0, 0, 0, 0.02)'}
              onChange={e => updateElement(selectedElement.id, { answerBackgroundColor: e.target.value })}
              sx={{ mb: 2 }}
              inputProps={{ type: 'color' }}
            />
    
            <TextField
              fullWidth
              label="Question Text Color"
              value={selectedElement.questionTextColor || '#4B329A'}
              onChange={e => updateElement(selectedElement.id, { questionTextColor: e.target.value })}
              sx={{ mb: 2 }}
              inputProps={{ type: 'color' }}
            />
    
            <TextField
              fullWidth
              label="Answer Text Color"
              value={selectedElement.answerTextColor || '#4B329A'}
              onChange={e => updateElement(selectedElement.id, { answerTextColor: e.target.value })}
              sx={{ mb: 2 }}
              inputProps={{ type: 'color' }}
            />
    
            <TextField
              fullWidth
              label="Title Text Color"
              value={selectedElement.titleTextColor || 'primary'}
              onChange={e => updateElement(selectedElement.id, { titleTextColor: e.target.value })}
              sx={{ mb: 2 }}
              inputProps={{ type: 'color' }}
            />
          </Box>
    
          {/* Spacing */}
          <Box sx={{ mb: 2, p: 2, border: '1px solid #eee', borderRadius: 1, backgroundColor: '#f9f9f9' }}>
            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Spacing
            </Typography>
    
            <TextField
              fullWidth
              label="Question Padding"
              value={selectedElement.questionPadding || '16px'}
              onChange={e => updateElement(selectedElement.id, { questionPadding: e.target.value })}
              sx={{ mb: 2 }}
              placeholder="e.g., 16px, 1rem, 8px 16px"
            />
    
            <TextField
              fullWidth
              label="Answer Padding"
              value={selectedElement.answerPadding || '16px'}
              onChange={e => updateElement(selectedElement.id, { answerPadding: e.target.value })}
              placeholder="e.g., 16px, 1rem, 8px 16px"
            />
          </Box>
    
          {selectedElement.items.map((item, idx) => (
            <Box key={idx} sx={{ mb: 2, p: 1, border: '1px solid #eee', borderRadius: 1 }}>
              <TextField
                fullWidth
                label={`Question ${idx + 1}`}
                value={item.question}
                onChange={e => {
                  const newItems = [...selectedElement.items];
                  newItems[idx] = { ...newItems[idx], question: e.target.value };
                  updateElement(selectedElement.id, { items: newItems });
                }}
                sx={{ mb: 1 }}
              />
              <TextField
                fullWidth
                label={`Answer ${idx + 1}`}
                value={item.answer}
                onChange={e => {
                  const newItems = [...selectedElement.items];
                  newItems[idx] = { ...newItems[idx], answer: e.target.value };
                  updateElement(selectedElement.id, { items: newItems });
                }}
                multiline
                rows={2}
              />
              <Button
                color="error"
                size="small"
                sx={{ mt: 1 }}
                onClick={() => {
                  const newItems = selectedElement.items.filter((_, i) => i !== idx);
                  updateElement(selectedElement.id, { items: newItems });
                }}
              >
                Remove
              </Button>
            </Box>
          ))}
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              const newItems = [...selectedElement.items, { question: '', answer: '' }];
              updateElement(selectedElement.id, { items: newItems });
            }}
          >
            Add FAQ Item
          </Button>
        </Box>
      )}
      {selectedElement.type === ELEMENT_TYPES.COMPARISON_TABLE && (
        <Box>
          <TextField
            fullWidth
            label="Table Title"
            value={selectedElement.title}
            onChange={e => updateElement(selectedElement.id, { title: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Product A Name"
            value={selectedElement.productA}
            onChange={e => updateElement(selectedElement.id, { productA: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Product B Name"
            value={selectedElement.productB}
            onChange={e => updateElement(selectedElement.id, { productB: e.target.value })}
            sx={{ mb: 2 }}
          />
    
          {/* Product A Image */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Product A Image (Optional)
            </Typography>
            <TextField
              fullWidth
              label="Product A Image URL"
              value={selectedElement.productAImage || ''}
              onChange={(e) => updateElement(selectedElement.id, { productAImage: e.target.value })}
              sx={{ mb: 1 }}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    handleImageUpload(file, selectedElement.id, false, selectedElementContext, 'productAImage');
                  }
                }}
                style={{ display: 'none' }}
                id={`product-a-image-upload-${selectedElement.id}`}
              />
              <label htmlFor={`product-a-image-upload-${selectedElement.id}`}>
                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<UploadIcon />}
                  disabled={imageUploading && uploadingElementId === selectedElement.id}
                  size="small"
                >
                  Upload
                </Button>
              </label>
              {selectedElement.productAImage && (
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={() => updateElement(selectedElement.id, { productAImage: '' })}
                >
                  Remove
                </Button>
              )}
            </Box>
          </Box>
    
          {/* Product B Image */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Product B Image (Optional)
            </Typography>
            <TextField
              fullWidth
              label="Product B Image URL"
              value={selectedElement.productBImage || ''}
              onChange={(e) => updateElement(selectedElement.id, { productBImage: e.target.value })}
              sx={{ mb: 1 }}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    handleImageUpload(file, selectedElement.id, false, selectedElementContext, 'productBImage');
                  }
                }}
                style={{ display: 'none' }}
                id={`product-b-image-upload-${selectedElement.id}`}
              />
              <label htmlFor={`product-b-image-upload-${selectedElement.id}`}>
                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<UploadIcon />}
                  disabled={imageUploading && uploadingElementId === selectedElement.id}
                  size="small"
                >
                  Upload
                </Button>
              </label>
              {selectedElement.productBImage && (
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={() => updateElement(selectedElement.id, { productBImage: '' })}
                >
                  Remove
                </Button>
              )}
            </Box>
          </Box>
          {selectedElement.rows.map((row, idx) => (
            <Box key={idx} sx={{ mb: 2, p: 1, border: '1px solid #eee', borderRadius: 1 }}>
              <TextField
                fullWidth
                label={`Feature ${idx + 1}`}
                value={row.feature}
                onChange={e => {
                  const newRows = [...selectedElement.rows];
                  newRows[idx] = { ...newRows[idx], feature: e.target.value };
                  updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                }}
                sx={{ mb: 1 }}
              />
              <TextField
                fullWidth
                label={`Description ${idx + 1}`}
                value={row.description}
                onChange={e => {
                  const newRows = [...selectedElement.rows];
                  newRows[idx] = { ...newRows[idx], description: e.target.value };
                  updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                }}
                sx={{ mb: 1 }}
              />
              <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                <FormControl size="small" sx={{ minWidth: 120 }}>
                  <InputLabel>Product A</InputLabel>
                  <Select
                    value={row.productA}
                    onChange={e => {
                      const newRows = [...selectedElement.rows];
                      newRows[idx] = { ...newRows[idx], productA: e.target.value };
                      updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                    }}
                  >
                    <MenuItem value={true}>✓ Yes</MenuItem>
                    <MenuItem value={false}>✗ No</MenuItem>
                  </Select>
                </FormControl>
                <FormControl size="small" sx={{ minWidth: 120 }}>
                  <InputLabel>Product B</InputLabel>
                  <Select
                    value={row.productB}
                    onChange={e => {
                      const newRows = [...selectedElement.rows];
                      newRows[idx] = { ...newRows[idx], productB: e.target.value };
                      updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                    }}
                  >
                    <MenuItem value={true}>✓ Yes</MenuItem>
                    <MenuItem value={false}>✗ No</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Button
                color="error"
                size="small"
                onClick={() => {
                  const newRows = selectedElement.rows.filter((_, i) => i !== idx);
                  updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                }}
              >
                Remove Row
              </Button>
            </Box>
          ))}
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              const newRows = [...selectedElement.rows, { feature: '', description: '', productA: true, productB: false }];
              updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
            }}
          >
            Add Row
          </Button>
        </Box>
      )}
      {selectedElement.type === ELEMENT_TYPES.STAR_RATING_TABLE && (
        <Box>
          <TextField
            fullWidth
            label="Table Title (Optional)"
            value={selectedElement.title || ''}
            onChange={e => updateElement(selectedElement.id, { title: e.target.value })}
            sx={{ mb: 3 }}
          />
    
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedElement.showRowDividers !== false}
                onChange={e => updateElement(selectedElement.id, { showRowDividers: e.target.checked })}
              />
            }
            label="Show dividing lines between rows"
            sx={{ mb: 2 }}
          />
    
          <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 'bold' }}>
            Rating Rows
          </Typography>
    
          {(selectedElement.rows || []).map((row, idx) => (
            <Box key={idx} sx={{ mb: 3, p: 2, border: '1px solid #eee', borderRadius: 2, backgroundColor: '#fcfcfc' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'text.secondary' }}>
                  Row #{idx + 1}
                </Typography>
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => {
                    const newRows = selectedElement.rows.filter((_, i) => i !== idx);
                    updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                  }}
                >
                  <DeleteIcon fontSize="inherit" />
                </IconButton>
              </Box>
    
              <TextField
                fullWidth
                label="Label"
                placeholder="e.g., Formula Potency"
                value={row.label || ''}
                onChange={e => {
                  const newRows = [...selectedElement.rows];
                  newRows[idx] = { ...newRows[idx], label: e.target.value };
                  updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                }}
                sx={{ mb: 2 }}
                size="small"
              />
    
              <Box sx={{ mb: 2, px: 1 }}>
                <Typography variant="caption" color="text.secondary" gutterBottom display="block">
                  Rating: {row.rating}
                </Typography>
                <Slider
                  key={`row-rating-${idx}-${selectedElement.id}`}
                  defaultValue={row.rating}
                  onChangeCommitted={(e, val) => {
                    const newRows = [...selectedElement.rows];
                    newRows[idx] = { ...newRows[idx], rating: val };
                    updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                  }}
                  step={0.5}
                  min={0}
                  max={selectedElement.maxStars || 5}
                  valueLabelDisplay="auto"
                  size="small"
                />
              </Box>
    
              <TextField
                fullWidth
                label="Rating Text (e.g., Excellent)"
                value={row.ratingText || ''}
                onChange={e => {
                  const newRows = [...selectedElement.rows];
                  newRows[idx] = { ...newRows[idx], ratingText: e.target.value };
                  updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                }}
                sx={{ mb: 1 }}
                size="small"
              />
            </Box>
          ))}
    
          <Button
            fullWidth
            variant="outlined"
            size="medium"
            startIcon={<AddIcon />}
            onClick={() => {
              const newRows = [...(selectedElement.rows || []), { id: Date.now().toString(), label: 'New Metric', rating: 5, ratingText: '' }];
              updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
            }}
            sx={{ mt: 1 }}
          >
            Add Rating Row
          </Button>
        </Box>
      )}
      {selectedElement.type === ELEMENT_TYPES.TWO_COLUMN_COMPARISON && (
        <Box>
          <TextField
            fullWidth
            label="Left Column Title"
            value={selectedElement.leftColumnTitle}
            onChange={e => updateElement(selectedElement.id, { leftColumnTitle: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Right Column Title"
            value={selectedElement.rightColumnTitle}
            onChange={e => updateElement(selectedElement.id, { rightColumnTitle: e.target.value })}
            sx={{ mb: 2 }}
          />
    
          {/* Left Column Image */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Left Column Image (Optional)
            </Typography>
            <TextField
              fullWidth
              label="Left Column Image URL"
              value={selectedElement.leftColumnImage || ''}
              onChange={(e) => updateElement(selectedElement.id, { leftColumnImage: e.target.value })}
              sx={{ mb: 1 }}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    handleImageUpload(file, selectedElement.id, false, selectedElementContext, 'leftColumnImage');
                  }
                }}
                style={{ display: 'none' }}
                id={`left-column-image-upload-${selectedElement.id}`}
              />
              <label htmlFor={`left-column-image-upload-${selectedElement.id}`}>
                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<UploadIcon />}
                  disabled={imageUploading && uploadingElementId === selectedElement.id}
                  size="small"
                >
                  Upload
                </Button>
              </label>
              {selectedElement.leftColumnImage && (
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={() => updateElement(selectedElement.id, { leftColumnImage: '' })}
                >
                  Remove
                </Button>
              )}
            </Box>
          </Box>
    
          {/* Right Column Image */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Right Column Image (Optional)
            </Typography>
            <TextField
              fullWidth
              label="Right Column Image URL"
              value={selectedElement.rightColumnImage || ''}
              onChange={(e) => updateElement(selectedElement.id, { rightColumnImage: e.target.value })}
              sx={{ mb: 1 }}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    handleImageUpload(file, selectedElement.id, false, selectedElementContext, 'rightColumnImage');
                  }
                }}
                style={{ display: 'none' }}
                id={`right-column-image-upload-${selectedElement.id}`}
              />
              <label htmlFor={`right-column-image-upload-${selectedElement.id}`}>
                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<UploadIcon />}
                  disabled={imageUploading && uploadingElementId === selectedElement.id}
                  size="small"
                >
                  Upload
                </Button>
              </label>
              {selectedElement.rightColumnImage && (
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={() => updateElement(selectedElement.id, { rightColumnImage: '' })}
                >
                  Remove
                </Button>
              )}
            </Box>
          </Box>
    
          {/* Left Column Items */}
          <Typography variant="h6" sx={{ mb: 1, mt: 3 }}>Left Column Items (Negative Points)</Typography>
          {selectedElement.leftItems && selectedElement.leftItems.map((item, idx) => (
            <Box key={idx} sx={{ mb: 2, p: 1, border: '1px solid #eee', borderRadius: 1 }}>
              <TextField
                fullWidth
                label={`Negative Point ${idx + 1}`}
                value={item}
                onChange={e => {
                  const newItems = [...selectedElement.leftItems];
                  newItems[idx] = e.target.value;
                  updateElement(selectedElement.id, { leftItems: newItems });
                }}
                sx={{ mb: 1 }}
                multiline
                rows={2}
              />
              <Button
                color="error"
                size="small"
                onClick={() => {
                  const newItems = selectedElement.leftItems.filter((_, i) => i !== idx);
                  updateElement(selectedElement.id, { leftItems: newItems });
                }}
              >
                Remove Item
              </Button>
            </Box>
          ))}
          <Button
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            onClick={() => {
              const newItems = [...(selectedElement.leftItems || []), 'New negative point'];
              updateElement(selectedElement.id, { leftItems: newItems });
            }}
          >
            Add Left Item
          </Button>
    
          {/* Right Column Items */}
          <Typography variant="h6" sx={{ mb: 1, mt: 2 }}>Right Column Items (Positive Points)</Typography>
          {selectedElement.rightItems && selectedElement.rightItems.map((item, idx) => (
            <Box key={idx} sx={{ mb: 2, p: 1, border: '1px solid #eee', borderRadius: 1 }}>
              <TextField
                fullWidth
                label={`Positive Point ${idx + 1}`}
                value={item}
                onChange={e => {
                  const newItems = [...selectedElement.rightItems];
                  newItems[idx] = e.target.value;
                  updateElement(selectedElement.id, { rightItems: newItems });
                }}
                sx={{ mb: 1 }}
                multiline
                rows={2}
              />
              <Button
                color="error"
                size="small"
                onClick={() => {
                  const newItems = selectedElement.rightItems.filter((_, i) => i !== idx);
                  updateElement(selectedElement.id, { rightItems: newItems });
                }}
              >
                Remove Item
              </Button>
            </Box>
          ))}
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              const newItems = [...(selectedElement.rightItems || []), 'New positive point'];
              updateElement(selectedElement.id, { rightItems: newItems });
            }}
          >
            Add Right Item
          </Button>
        </Box>
      )}
      {selectedElement.type === ELEMENT_TYPES.HEADING && (
        <TextField
          fullWidth
          label="Heading Text"
          value={contentTabTempValue !== '' ? contentTabTempValue : selectedElement.content}
          onChange={(e) => setContentTabTempValue(e.target.value)}
          onKeyDown={handleContentTabKeyPress}
          onBlur={saveContentTabEdit}
          sx={{ mb: 2 }}
        />
      )}
      {selectedElement.type === ELEMENT_TYPES.TEXT && (
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Text Content"
          value={contentTabTempValue !== '' ? contentTabTempValue : selectedElement.content}
          onChange={(e) => setContentTabTempValue(e.target.value)}
          onKeyDown={handleContentTabKeyPress}
          onBlur={saveContentTabEdit}
          sx={{ mb: 2 }}
        />
      )}
      {selectedElement.type === ELEMENT_TYPES.STAR_RATING && (
        <>
          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" gutterBottom>
              Target Rating
            </Typography>
            <Slider
              key={`rating-${selectedElement.id}`}
              defaultValue={selectedElement.rating || 5}
              onChangeCommitted={(e, value) => {
                updateElement(selectedElement.id, { rating: value }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
              }}
              step={0.5}
              marks
              min={0}
              max={selectedElement.maxStars || 5}
              valueLabelDisplay="auto"
            />
          </Box>
          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" gutterBottom>
              Max Stars
            </Typography>
            <Slider
              key={`maxStars-${selectedElement.id}`}
              defaultValue={selectedElement.maxStars || 5}
              onChangeCommitted={(e, value) => {
                updateElement(selectedElement.id, { maxStars: value }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
              }}
              step={1}
              marks
              min={1}
              max={10}
              valueLabelDisplay="auto"
            />
          </Box>
          <FormControlLabel
            control={
              <Switch
                checked={selectedElement.showRatingText || false}
                onChange={(e) => {
                  updateElement(selectedElement.id, { showRatingText: e.target.checked }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                }}
              />
            }
            label="Show text label (e.g. 5/5)"
            sx={{ mb: 2 }}
          />
          {selectedElement.showRatingText && (
            <Box sx={{ mb: 3 }}>
              <TextField
                fullWidth
                label="Rating Text"
                value={localRatingText}
                onChange={(e) => {
                  setLocalRatingText(e.target.value);
                  // skipSelectedSync=true: updates canvas without triggering setSelectedElement re-render (which would steal focus)
                  updateElement(selectedElement.id, { ratingText: e.target.value }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId, true);
                }}
                onBlur={(e) => {
                  // Full sync on blur so the sidebar panel reflects final value
                  updateElement(selectedElement.id, { ratingText: e.target.value }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                }}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                select
                label="Text Position"
                value={selectedElement.ratingTextPosition || 'left'}
                onChange={(e) => {
                  updateElement(selectedElement.id, { ratingTextPosition: e.target.value }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                }}
                sx={{ mb: 2 }}
              >
                <MenuItem value="left">Left of Stars</MenuItem>
                <MenuItem value="right">Right of Stars</MenuItem>
                <MenuItem value="top">Top of Stars</MenuItem>
                <MenuItem value="bottom">Bottom of Stars</MenuItem>
              </TextField>
    
              {/* Gap between text label and stars */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" gutterBottom>
                  Text–Stars Spacing: {typeof selectedElement.ratingTextGap === 'string' ? selectedElement.ratingTextGap : (selectedElement.ratingTextGap || '8px')}
                </Typography>
                <Slider
                  key={`ratingTextGap-${selectedElement.id}`}
                  defaultValue={parseInt(selectedElement.ratingTextGap) || 8}
                  onChangeCommitted={(e, value) => {
                    updateElement(selectedElement.id, { ratingTextGap: `${value}px` }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                  }}
                  step={1}
                  min={0}
                  max={40}
                  valueLabelDisplay="auto"
                />
              </Box>
    
              {/* Text Style Preset Picker */}
              <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f8f9fa' }}>
                <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                  🎨 Label Text Style
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                  Choose a preset style for the rating label text.
                </Typography>
                <SimplePresetSelector
                  onStyleSelect={(presetName, preset) => {
                    updateElement(selectedElement.id, {
                      ratingTextStylePreset: presetName,
                      ratingTextStyles: preset
                    }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                  }}
                  currentStyle={selectedElement.ratingTextStylePreset}
                  presetFilter={(presetName) =>
                    !presetName.includes('quotation') &&
                    !presetName.includes('bullet') &&
                    !presetName.includes('compareTable') &&
                    !presetName.includes('button')
                  }
                />
              </Box>
            </Box>
          )}
        </>
      )}
      {selectedElement.type === ELEMENT_TYPES.IMAGE && (
        <>
          <TextField
            fullWidth
            label="Image URL"
            value={selectedElement.content}
            onChange={(e) => updateElement(selectedElement.id, { content: e.target.value })}
            sx={{ mb: 2 }}
          />
    
          {/* File Upload Section */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Or Upload Image
            </Typography>
            <S3FileUpload
              onUploadComplete={({ url }) => {
                console.log('🖼️ Image upload completed:', { url, elementId: selectedElement.id });
                updateElement(selectedElement.id, { content: url }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                // Also update selectedElement directly to ensure immediate UI update
                setSelectedElement(prev => ({ ...prev, content: url }));
              }}
              onUploadError={(error) => {
                console.error('❌ Image upload failed:', error);
                setStatusTitle('Image Upload Failed');
                setStatusMessage(`Image upload failed: ${error.message}`);
                setShowStatusAlert(true);
              }}
              acceptedTypes="image/*"
              buttonText="Upload Image"
              buttonSize="medium"
              startIcon={<UploadIcon />}
              folder="offer-templates/images"
              showProgress={true}
              fullWidth={false}
            />
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
              Supported formats: JPG, PNG, GIF, WEBP (max 5MB)
            </Typography>
          </Box>
    
          <TextField
            fullWidth
            label="Alt Text"
            value={selectedElement.alt || ''}
            onChange={(e) => updateElement(selectedElement.id, { alt: e.target.value })}
            sx={{ mb: 2 }}
          />
        </>
      )}
      {selectedElement.type === ELEMENT_TYPES.CROPPABLE_IMAGE && (
        <>
          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
            Croppable Image
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
            Upload an image and use the crop tool to adjust the view. The cropped image will be saved automatically.
          </Typography>
    
          {/* File Upload Section */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Upload Image
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const reader = new FileReader();
                    reader.onload = (ev) => {
                      const imageSrc = ev.target.result;
                      updateElement(selectedElement.id, {
                        imageSrc,
                        croppedImage: '',
                        crop: { x: 0, y: 0 },
                        zoom: 1,
                        croppedAreaPixels: null
                      }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                    };
                    reader.readAsDataURL(file);
                  }
                }}
                style={{ display: 'none' }}
                id={`croppable-image-upload-${selectedElement.id}`}
              />
              <label htmlFor={`croppable-image-upload-${selectedElement.id}`}>
                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<UploadIcon />}
                  sx={{ minWidth: 120 }}
                >
                  Upload Image
                </Button>
              </label>
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
              Supported formats: JPG, PNG, GIF, WEBP (max 5MB)
            </Typography>
          </Box>
        </>
      )}
      {(selectedElement.type === ELEMENT_TYPES.FITTABLE_IMAGE || selectedElement.type === ELEMENT_TYPES.IMAGE_OVERLAY) && (
        <>
          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
            {selectedElement.type === ELEMENT_TYPES.IMAGE_OVERLAY ? 'Background Image (Fittable)' : 'Fittable Image'}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
            Upload an image and position it within a fixed frame. Drag to position, scroll to zoom, and use presets for common aspect ratios.
          </Typography>
    
          {/* File Upload Section */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Upload Image
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const reader = new FileReader();
                    reader.onload = (ev) => {
                      const imageSrc = ev.target.result;
                      updateElement(selectedElement.id, {
                        imageSrc,
                        imagePosition: { x: 0, y: 0 },
                        imageScale: 1
                      }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                    };
                    reader.readAsDataURL(file);
                  }
                }}
                style={{ display: 'none' }}
                id={`fittable-image-upload-${selectedElement.id}`}
              />
              <label htmlFor={`fittable-image-upload-${selectedElement.id}`}>
                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<UploadIcon />}
                  sx={{ minWidth: 120 }}
                >
                  Upload Image
                </Button>
              </label>
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
              Supported formats: JPG, PNG, GIF, WEBP (max 5MB) • Images stored locally
            </Typography>
          </Box>
    
          {/* Frame Dimensions */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Frame Dimensions
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <TextField
                label="Width"
                type="number"
                value={selectedElement.styles?.width === "100%" ? 400 : (typeof selectedElement.styles?.width === 'number' ? selectedElement.styles.width : 400)}
                onChange={(e) => {
                  const newWidth = parseInt(e.target.value) || 400;
                  updateElement(selectedElement.id, {
                    styles: {
                      ...selectedElement.styles,
                      width: newWidth
                    }
                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                }}
                sx={{ flex: 1 }}
                inputProps={{ min: 100, max: 1200 }}
              />
              <Typography variant="body2">×</Typography>
              <TextField
                label="Height"
                type="number"
                value={selectedElement.styles?.height || 300}
                onChange={(e) => {
                  const newHeight = parseInt(e.target.value) || 300;
                  updateElement(selectedElement.id, {
                    styles: {
                      ...selectedElement.styles,
                      height: newHeight
                    }
                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                }}
                sx={{ flex: 1 }}
                inputProps={{ min: 50, max: 800 }}
              />
            </Box>
            <FormControlLabel
              control={
                <Switch
                  checked={selectedElement.styles?.width === "100%"}
                  onChange={(e) => {
                    updateElement(selectedElement.id, {
                      styles: {
                        ...selectedElement.styles,
                        width: e.target.checked ? "100%" : 400
                      }
                    }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                  }}
                />
              }
              label="Full Width (Responsive)"
              sx={{ mt: 1 }}
            />
          </Box>
    
          {/* Image Scale Slider */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Image Scale (Zoom)
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Slider
                value={selectedElement.imageScale || 1}
                min={0.1}
                max={3}
                step={0.01}
                onChangeCommitted={(_, value) => {
                  updateElement(selectedElement.id, {
                    imageScale: value,
                    imagePosition: { x: 0, y: 0 }
                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                }}
                sx={{ flex: 1 }}
              />
              <Typography variant="caption" sx={{ minWidth: 40 }}>
                {Math.round((selectedElement.imageScale || 1) * 100)}%
              </Typography>
            </Box>
          </Box>
        </>
      )}
      {(selectedElement.type === ELEMENT_TYPES.BUTTON || selectedElement.type === ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY) && (
        <>
          <TextField
            fullWidth
            label="Button Text"
            value={buttonContentTabTempValue !== '' ? buttonContentTabTempValue : selectedElement.content}
            onChange={(e) => setButtonContentTabTempValue(e.target.value)}
            onKeyDown={handleButtonContentTabKeyPress}
            onBlur={saveButtonContentTabEdit}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Button URL"
            value={buttonUrlTabTempValue !== '' ? buttonUrlTabTempValue : selectedElement.url}
            onChange={(e) => setButtonUrlTabTempValue(e.target.value)}
            onKeyDown={handleButtonUrlTabKeyPress}
            onBlur={saveButtonUrlTabEdit}
            disabled={isBrandsPage}
            sx={{ mb: 2 }}
          />
    
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Button Alignment
            </Typography>
            <ToggleButtonGroup
              size="small"
              exclusive
              value={selectedElement.styles?.textAlign || 'center'}
              onChange={(_, next) => {
                if (!next) return;
                updateElement(
                  selectedElement.id,
                  { styles: { ...selectedElement.styles, textAlign: next } },
                  selectedElementContext?.isInZone,
                  selectedElementContext?.layoutId,
                  selectedElementContext?.zoneId
                );
                setSelectedElement(prev => ({ ...prev, styles: { ...(prev.styles || {}), textAlign: next } }));
              }}
              sx={{ width: '100%' }}
            >
              <ToggleButton value="left" sx={{ flex: 1, textTransform: 'none' }}>Left</ToggleButton>
              <ToggleButton value="center" sx={{ flex: 1, textTransform: 'none' }}>Center</ToggleButton>
              <ToggleButton value="right" sx={{ flex: 1, textTransform: 'none' }}>Right</ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </>
      )}
    
      {/* Two-Line Custom List Content Controls */}
      {selectedElement.type === ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE && (
        <>
          {selectedElement.rows.map((row, idx) => (
            <Box key={idx} sx={{ display: 'flex', flexDirection: 'column', mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
              {/* Icon Selector */}
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Typography variant="body2" sx={{ mr: 1, minWidth: 40 }}>Icon:</Typography>
                <Select
                  value={row.icon}
                  onChange={e => {
                    const newRows = [...selectedElement.rows];
                    newRows[idx].icon = e.target.value;
                    updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                  }}
                  sx={{ minWidth: 120 }}
                  size="small"
                >
                  <MenuItem value="check"><VerifiedIcon sx={{ color: '#b6ff3c' }} /></MenuItem>
                  <MenuItem value="red-x"><CancelIcon sx={{ color: '#f44336' }} /></MenuItem>
                  <MenuItem value="green-check-simple"><CheckMarkIcon sx={{ color: '#22c55e' }} /></MenuItem>
                  <MenuItem value="red-x-simple"><CloseMarkIcon sx={{ color: '#ff3b30' }} /></MenuItem>
                  <MenuItem value="pink-check"><CheckCircleIcon sx={{ color: '#eabbc3' }} /></MenuItem>
                  <MenuItem value="dark-check"><CheckCircleIcon sx={{ color: '#333' }} /></MenuItem>
                  <MenuItem value="green-badge">
                    <Box sx={{
                      width: 20, height: 20, borderRadius: '50%', background: '#22c55e',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: '0.8rem', color: 'white', fontWeight: 'bold'
                    }}>
                      ✓
                    </Box>
                  </MenuItem>
                  <MenuItem value="star-badge">
                    <Box sx={{
                      width: 20, height: 20, borderRadius: '50%', background: '#5a67d8',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: '0.8rem', color: 'white', fontWeight: 'bold'
                    }}>
                      ⭐
                    </Box>
                  </MenuItem>
                  <MenuItem value="star"><StarIcon sx={{ color: '#ffe066' }} /></MenuItem>
                  <MenuItem value="info"><InfoIcon sx={{ color: '#40c4ff' }} /></MenuItem>
                  <MenuItem value="warning"><WarningIcon sx={{ color: '#ffb347' }} /></MenuItem>
                </Select>
              </Box>
    
              {/* First Text Line (Title) */}
              <Box sx={{ mb: 1 }}>
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 'bold' }}>Title (Line 1):</Typography>
                <TextField
                  value={listItemTextValues[`${selectedElement.id}-${idx}-text1`] !== undefined
                    ? listItemTextValues[`${selectedElement.id}-${idx}-text1`]
                    : row.text1}
                  onChange={e => {
                    const key = `${selectedElement.id}-${idx}-text1`;
                    setListItemTextValues(prev => ({
                      ...prev,
                      [key]: e.target.value
                    }));
                  }}
                  onBlur={() => {
                    const key = `${selectedElement.id}-${idx}-text1`;
                    const newValue = listItemTextValues[key];
                    if (newValue !== undefined) {
                      const newRows = [...selectedElement.rows];
                      newRows[idx].text1 = newValue;
                      updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                      setListItemTextValues(prev => {
                        const updated = { ...prev };
                        delete updated[key];
                        return updated;
                      });
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault();
                      const key = `${selectedElement.id}-${idx}-text1`;
                      const newValue = listItemTextValues[key];
                      if (newValue !== undefined) {
                        const newRows = [...selectedElement.rows];
                        newRows[idx].text1 = newValue;
                        updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                        setListItemTextValues(prev => {
                          const updated = { ...prev };
                          delete updated[key];
                          return updated;
                        });
                        e.target.blur();
                      }
                    }
                  }}
                  fullWidth
                  size="small"
                  placeholder="Feature title"
                  autoFocus={false}
                />
              </Box>
    
              {/* Second Text Line (Description) */}
              <Box sx={{ mb: 1 }}>
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 'bold' }}>Description (Line 2):</Typography>
                <TextField
                  value={listItemTextValues[`${selectedElement.id}-${idx}-text2`] !== undefined
                    ? listItemTextValues[`${selectedElement.id}-${idx}-text2`]
                    : row.text2}
                  onChange={e => {
                    const key = `${selectedElement.id}-${idx}-text2`;
                    setListItemTextValues(prev => ({
                      ...prev,
                      [key]: e.target.value
                    }));
                  }}
                  onBlur={() => {
                    const key = `${selectedElement.id}-${idx}-text2`;
                    const newValue = listItemTextValues[key];
                    if (newValue !== undefined) {
                      const newRows = [...selectedElement.rows];
                      newRows[idx].text2 = newValue;
                      updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                      setListItemTextValues(prev => {
                        const updated = { ...prev };
                        delete updated[key];
                        return updated;
                      });
                    }
                  }}
                  fullWidth
                  size="small"
                  multiline
                  rows={2}
                  placeholder="Feature description"
                  autoFocus={false}
                />
              </Box>
    
              {/* Row Actions */}
              <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                <IconButton
                  size="small"
                  onClick={() => {
                    // Duplicate the current row and insert it below
                    const newRows = [...selectedElement.rows];
                    const duplicatedRow = {
                      ...row,
                      text1: `${row.text1} (copy)`,
                      text2: `${row.text2} (copy)`
                    };
                    newRows.splice(idx + 1, 0, duplicatedRow);
                    updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                  }}
                  title="Duplicate row"
                >
                  <DuplicateIcon />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => {
                    const newRows = selectedElement.rows.filter((_, i) => i !== idx);
                    updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                  }}
                  title="Remove row"
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Box>
          ))}
    
          <Button
            onClick={() => {
              const newRows = [...selectedElement.rows, {
                icon: 'check',
                text1: 'New Feature',
                text2: 'Description of the new feature'
              }];
              updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
              setSelectedElement({ ...selectedElement, rows: newRows });
            }}
            startIcon={<AddIcon />}
            sx={{ mb: 2 }}
          >
            Add Row
          </Button>
        </>
      )}
    
      {selectedElement.type === ELEMENT_TYPES.VIDEO && (
        <>
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Upload Video File</Typography>
            <S3FileUpload
              onUploadComplete={({ url }) => {
                console.log('🎥 Video upload completed:', { url, elementId: selectedElement.id });
                updateElement(selectedElement.id, { videoFile: url }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                // Force immediate re-render for video updates
                console.log('🔄 Forcing immediate re-render after video upload');
                setForceRender(prev => prev + 1);
                // Also update selectedElement directly to ensure immediate UI update
                setSelectedElement(prev => ({ ...prev, videoFile: url }));
              }}
              onUploadError={(error) => {
                console.error('❌ Video upload failed:', error);
                setStatusTitle('Video Upload Failed');
                setStatusMessage(`Video upload failed: ${error.message}`);
                setShowStatusAlert(true);
              }}
              acceptedTypes="video/*"
              buttonText="Choose Video File"
              buttonSize="small"
              startIcon={<VideoIcon />}
              folder="offer-templates/videos"
              showProgress={true}
            />
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1 }}>
              {selectedElement.videoFile && (
                <Button
                  variant="text"
                  color="error"
                  size="small"
                  onClick={() => updateElement(selectedElement.id, { videoFile: '' }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                >
                  Remove Video
                </Button>
              )}
            </Box>
            {selectedElement.videoFile && (
              <>
                <Box sx={{ border: '1px solid #eee', borderRadius: 1, p: 1, display: 'inline-block' }}>
                  <video
                    src={selectedElement.videoFile}
                    controls
                    style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
                  />
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                  Video uploaded successfully! It will be displayed in the exported HTML.
                </Typography>
              </>
            )}
          </Box>
    
          {/* Video Thumbnail Upload - MANDATORY for video elements */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Upload Video Thumbnail (Required)</Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
              Upload a thumbnail image that will be displayed before the video plays. This is required for video elements.
            </Typography>
            {selectedElement.videoFile && !selectedElement.thumbnailUrl && (
              <Typography variant="caption" color="error" sx={{ display: 'block', mb: 1, fontWeight: 'bold' }}>
                ⚠️ Thumbnail is required for video elements. Please upload a thumbnail before saving.
              </Typography>
            )}
    
            {(!selectedElement.thumbnailUrl) && (
              <Box sx={{ mb: 1 }}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const uploadedUrl = await handleThumbnailUpload(file, selectedElement.id, selectedElementContext);
                      if (uploadedUrl) {
                        console.log('🖼️ Thumbnail upload completed:', uploadedUrl);
                        updateElement(selectedElement.id, { thumbnailUrl: uploadedUrl }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                        setForceRender(prev => prev + 1);
                        setSelectedElement(prev => ({ ...prev, thumbnailUrl: uploadedUrl }));
                      }
                    }
                  }}
                  style={{ display: 'none' }}
                  id={`thumbnail-upload-${selectedElement.id}`}
                />
                <label htmlFor={`thumbnail-upload-${selectedElement.id}`}>
                  <Button
                    variant="outlined"
                    component="span"
                    size="small"
                    fullWidth
                    startIcon={<ImageIcon />}
                    disabled={imageUploading && uploadingElementId === selectedElement.id}
                  >
                    {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Choose Thumbnail Image'}
                  </Button>
                </label>
              </Box>
            )}
    
            {selectedElement.thumbnailUrl && (
              <>
                <Box sx={{ textAlign: 'center', mb: 1 }}>
                  <img
                    src={selectedElement.thumbnailUrl}
                    alt="Video thumbnail"
                    style={{ maxWidth: '200px', height: 'auto', display: 'block', margin: '0 auto' }}
                  />
                </Box>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', mb: 1 }}>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const uploadedUrl = await handleThumbnailUpload(file, selectedElement.id, selectedElementContext);
                        if (uploadedUrl) {
                          console.log('🖼️ Thumbnail replacement completed:', uploadedUrl);
                          updateElement(selectedElement.id, { thumbnailUrl: uploadedUrl }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                          setForceRender(prev => prev + 1);
                          setSelectedElement(prev => ({ ...prev, thumbnailUrl: uploadedUrl }));
                        }
                      }
                    }}
                    style={{ display: 'none' }}
                    id={`thumbnail-replace-${selectedElement.id}`}
                  />
                  <label htmlFor={`thumbnail-replace-${selectedElement.id}`}>
                    <Button
                      variant="outlined"
                      component="span"
                      size="small"
                      disabled={imageUploading && uploadingElementId === selectedElement.id}
                    >
                      {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Replace Thumbnail'}
                    </Button>
                  </label>
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    onClick={() => {
                      updateElement(selectedElement.id, { thumbnailUrl: '' }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                      setForceRender(prev => prev + 1);
                      setSelectedElement(prev => ({ ...prev, thumbnailUrl: '' }));
                    }}
                  >
                    Remove Thumbnail
                  </Button>
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center' }}>
                  Thumbnail uploaded successfully! It will be used as the video poster.
                </Typography>
              </>
            )}
          </Box>
        </>
      )}
    
    
      {selectedElement.type === ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY && (
        <>
          {/* Video Upload Section - Same as VIDEO element */}
    
    
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Upload Video File</Typography>
            <S3FileUpload
              onUploadComplete={({ url }) => {
                updateElement(selectedElement.id, { videoFile: url }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                setForceRender(prev => prev + 1);
                setSelectedElement(prev => ({ ...prev, videoFile: url }));
              }}
              onUploadError={(error) => {
                setStatusTitle('Video Upload Failed');
                setStatusMessage(`Video upload failed: ${error.message}`);
                setShowStatusAlert(true);
              }}
              acceptedTypes="video/*"
              buttonText="Choose Video File"
              buttonSize="small"
              startIcon={<VideoIcon />}
              folder="offer-templates/videos"
              showProgress={true}
            />
            {selectedElement.videoFile && (
              <Button
                variant="text"
                color="error"
                size="small"
                onClick={() => updateElement(selectedElement.id, { videoFile: '' }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                sx={{ mt: 1 }}
              >
                Remove Video
              </Button>
            )}
          </Box>
    
          {/* Thumbnail Upload */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Video Thumbnail</Typography>
            <input
              type="file"
              accept="image/*"
              onChange={async (e) => {
                const file = e.target.files[0];
                if (file) {
                  const uploadedUrl = await handleThumbnailUpload(file, selectedElement.id, selectedElementContext);
                  if (uploadedUrl) {
                    updateElement(selectedElement.id, { thumbnailUrl: uploadedUrl }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                    setForceRender(prev => prev + 1);
                    setSelectedElement(prev => ({ ...prev, thumbnailUrl: uploadedUrl }));
                  }
                }
              }}
              style={{ display: 'none' }}
              id={`thumbnail-upload-overlay-${selectedElement.id}`}
            />
            <label htmlFor={`thumbnail-upload-overlay-${selectedElement.id}`}>
              <Button
                variant="outlined"
                component="span"
                size="small"
                fullWidth
                startIcon={<ImageIcon />}
              >
                {selectedElement.thumbnailUrl ? 'Change Thumbnail' : 'Upload Thumbnail'}
              </Button>
            </label>
            {selectedElement.thumbnailUrl && (
              <Box sx={{ mt: 1, textAlign: 'center' }}>
                <img
                  src={selectedElement.thumbnailUrl}
                  alt="Thumbnail"
                  style={{ maxWidth: '200px', height: 'auto' }}
                />
              </Box>
            )}
          </Box>
    
        </>
      )}
    
      {selectedElement.type === ELEMENT_TYPES.MEDIA && (
        <>
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              Upload image or video file
            </Typography>
    
            {/* File Input */}
            <input
              type="file"
              accept="image/*,video/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  handleMediaUploadForElement(file, selectedElement.id, selectedElementContext);
                }
                // Reset input to allow selecting the same file again
                e.target.value = '';
              }}
              style={{ display: 'none' }}
              id={`media-upload-${selectedElement.id}`}
              disabled={imageUploading && uploadingElementId === selectedElement.id}
            />
            <label htmlFor={`media-upload-${selectedElement.id}`}>
              <Button
                variant="outlined"
                component="span"
                fullWidth
                sx={{ mb: 1 }}
                disabled={imageUploading && uploadingElementId === selectedElement.id}
                startIcon={<UploadIcon />}
              >
                {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Choose image or video file'}
              </Button>
            </label>
    
            {/* Selected File Display */}
            {selectedElement.mediaUrl && (
              <Box sx={{
                mb: 1,
                p: 2,
                backgroundColor: '#e3f2fd',
                borderRadius: 1,
                border: '1px solid #1976d2'
              }}>
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 1 }}>
                  ✅ Media uploaded successfully
                </Typography>
                {selectedElement.mediaUrl.match(/\.(mp4|avi|mov|wmv|flv|webm)$/i) ? (
                  <Box sx={{ textAlign: 'center', mb: 1 }}>
                    <video
                      src={selectedElement.mediaUrl}
                      controls
                      poster={selectedElement.thumbnailUrl || undefined}
                      style={{
                        maxWidth: '100%',
                        maxHeight: '200px',
                        borderRadius: '8px'
                      }}
                    />
                  </Box>
                ) : (
                  <Box sx={{ textAlign: 'center', mb: 1 }}>
                    <img
                      src={selectedElement.mediaUrl}
                      alt="Media preview"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '200px',
                        borderRadius: '8px'
                      }}
                    />
                  </Box>
                )}
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', mt: 1 }}>
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    onClick={() => {
                      updateElement(selectedElement.id, { mediaUrl: '', thumbnailUrl: '' }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                      setForceRender(prev => prev + 1);
                      setSelectedElement(prev => ({ ...prev, mediaUrl: '', thumbnailUrl: '' }));
                    }}
                  >
                    Remove Media
                  </Button>
                </Box>
              </Box>
            )}
    
            {/* Video Thumbnail Upload - MANDATORY for videos */}
            {selectedElement.mediaUrl && selectedElement.mediaUrl.match(/\.(mp4|avi|mov|wmv|flv|webm)$/i) && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>Upload Video Thumbnail (Required)</Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                  Upload a thumbnail image that will be displayed before the video plays. This is required for video elements.
                </Typography>
                {!selectedElement.thumbnailUrl && (
                  <Typography variant="caption" color="error" sx={{ display: 'block', mb: 1, fontWeight: 'bold' }}>
                    ⚠️ Thumbnail is required for video elements. Please upload a thumbnail.
                  </Typography>
                )}
    
                {(!selectedElement.thumbnailUrl) && (
                  <Box sx={{ mb: 1 }}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const uploadedUrl = await handleThumbnailUpload(file, selectedElement.id, selectedElementContext);
                          if (uploadedUrl) {
                            console.log('🖼️ Thumbnail upload completed:', uploadedUrl);
                            updateElement(selectedElement.id, { thumbnailUrl: uploadedUrl }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                            setForceRender(prev => prev + 1);
                            setSelectedElement(prev => ({ ...prev, thumbnailUrl: uploadedUrl }));
                          }
                        }
                      }}
                      style={{ display: 'none' }}
                      id={`media-thumbnail-upload-${selectedElement.id}`}
                    />
                    <label htmlFor={`media-thumbnail-upload-${selectedElement.id}`}>
                      <Button
                        variant="outlined"
                        component="span"
                        size="small"
                        fullWidth
                        startIcon={<ImageIcon />}
                        disabled={imageUploading && uploadingElementId === selectedElement.id}
                      >
                        {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Choose Thumbnail Image'}
                      </Button>
                    </label>
                  </Box>
                )}
    
                {selectedElement.thumbnailUrl && (
                  <>
                    <Box sx={{ textAlign: 'center', mb: 1 }}>
                      <img
                        src={selectedElement.thumbnailUrl}
                        alt="Video thumbnail"
                        style={{ maxWidth: '200px', height: 'auto', display: 'block', margin: '0 auto' }}
                      />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', mb: 1 }}>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const uploadedUrl = await handleThumbnailUpload(file, selectedElement.id, selectedElementContext);
                            if (uploadedUrl) {
                              console.log('🖼️ Thumbnail replacement completed:', uploadedUrl);
                              updateElement(selectedElement.id, { thumbnailUrl: uploadedUrl }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              setForceRender(prev => prev + 1);
                              setSelectedElement(prev => ({ ...prev, thumbnailUrl: uploadedUrl }));
                            }
                          }
                        }}
                        style={{ display: 'none' }}
                        id={`media-thumbnail-replace-${selectedElement.id}`}
                      />
                      <label htmlFor={`media-thumbnail-replace-${selectedElement.id}`}>
                        <Button
                          variant="outlined"
                          component="span"
                          size="small"
                          startIcon={<ImageIcon />}
                          disabled={imageUploading && uploadingElementId === selectedElement.id}
                        >
                          Replace Thumbnail
                        </Button>
                      </label>
                    </Box>
                  </>
                )}
              </Box>
            )}
    
            {/* Frame Presets for Video - Only show when video is uploaded */}
            {selectedElement.mediaUrl && selectedElement.mediaUrl.match(/\.(mp4|avi|mov|wmv|flv|webm)$/i) && (
              <Box sx={{ mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f8f9fa' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <ImageIcon sx={{ fontSize: 20, color: '#666' }} />
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    Frame Presets
                  </Typography>
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                  Choose a frame style for your media.
                </Typography>
    
                <Box sx={{ display: 'flex', gap: 0, border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden' }}>
                  <Button
                    variant={selectedElement.styles?.aspectRatio === '1/1' ? 'contained' : 'text'}
                    size="small"
                    onClick={() => {
                      updateElement(selectedElement.id, {
                        styles: {
                          ...selectedElement.styles,
                          aspectRatio: '1/1'
                        }
                      }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                      setSelectedElement(prev => ({ ...prev, styles: { ...prev.styles, aspectRatio: '1/1' } }));
                    }}
                    sx={{
                      flex: 1,
                      borderRadius: 0,
                      borderRight: '1px solid #e0e0e0',
                      fontSize: '0.65rem',
                      fontWeight: selectedElement.styles?.aspectRatio === '1/1' ? 'bold' : 'normal',
                      py: 1
                    }}
                  >
                    SQUARE
                  </Button>
                  <Button
                    variant={selectedElement.styles?.aspectRatio === '16/9' ? 'contained' : 'text'}
                    size="small"
                    onClick={() => {
                      updateElement(selectedElement.id, {
                        styles: {
                          ...selectedElement.styles,
                          aspectRatio: '16/9'
                        }
                      }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                      setSelectedElement(prev => ({ ...prev, styles: { ...prev.styles, aspectRatio: '16/9' } }));
                    }}
                    sx={{
                      flex: 1,
                      borderRadius: 0,
                      borderRight: '1px solid #e0e0e0',
                      fontSize: '0.65rem',
                      fontWeight: selectedElement.styles?.aspectRatio === '16/9' ? 'bold' : 'normal',
                      py: 1
                    }}
                  >
                    LANDSCAPE
                  </Button>
                  <Button
                    variant={selectedElement.styles?.aspectRatio === '9/16' ? 'contained' : 'text'}
                    size="small"
                    onClick={() => {
                      updateElement(selectedElement.id, {
                        styles: {
                          ...selectedElement.styles,
                          aspectRatio: '9/16'
                        }
                      }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                      setSelectedElement(prev => ({ ...prev, styles: { ...prev.styles, aspectRatio: '9/16' } }));
                    }}
                    sx={{
                      flex: 1,
                      borderRadius: 0,
                      borderRight: '1px solid #e0e0e0',
                      fontSize: '0.65rem',
                      fontWeight: selectedElement.styles?.aspectRatio === '9/16' ? 'bold' : 'normal',
                      py: 1
                    }}
                  >
                    PORTRAIT
                  </Button>
                  <Button
                    variant={selectedElement.styles?.aspectRatio === '4/5' ? 'contained' : 'text'}
                    size="small"
                    onClick={() => {
                      updateElement(selectedElement.id, {
                        styles: {
                          ...selectedElement.styles,
                          aspectRatio: '4/5'
                        }
                      }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                      setSelectedElement(prev => ({ ...prev, styles: { ...prev.styles, aspectRatio: '4/5' } }));
                    }}
                    sx={{
                      flex: 1,
                      borderRadius: 0,
                      fontSize: '0.65rem',
                      fontWeight: selectedElement.styles?.aspectRatio === '4/5' ? 'bold' : 'normal',
                      py: 1
                    }}
                  >
                    PORTRAIT45
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        </>
      )}
    
      {selectedElement.type === ELEMENT_TYPES.HTML && (
        <TextField
          fullWidth
          multiline
          rows={6}
          label="HTML Content"
          value={selectedElement.content}
          onChange={(e) => updateElement(selectedElement.id, { content: e.target.value })}
          sx={{ mb: 2 }}
        />
      )}
      {/* Custom Button Elements */}
      {(selectedElement.type === 'BUTTON_WITH_NOTICE' ||
        selectedElement.type === 'BUTTON_IMAGE_CALLOUT' ||
        selectedElement.type === 'BUTTON_TEXT_VARIANT' ||
        selectedElement.type === 'BUTTON_HEADLINE_PRODUCT_IMAGE') && (
          <>
            <TextField
              fullWidth
              label="Button Text"
              value={selectedElement.content?.buttonText || ''}
              onChange={(e) => updateElement(selectedElement.id, {
                content: { ...selectedElement.content, buttonText: e.target.value }
              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Button URL"
              value={selectedElement.content?.buttonUrl || ''}
              onChange={(e) => updateElement(selectedElement.id, {
                content: { ...selectedElement.content, buttonUrl: e.target.value }
              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
              disabled={isBrandsPage}
              sx={{ mb: 2 }}
            />
            {selectedElement.type === 'BUTTON_WITH_NOTICE' && (
              <>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Notice Text"
                  value={selectedElement.content?.notice || ''}
                  onChange={(e) => updateElement(selectedElement.id, {
                    content: { ...selectedElement.content, notice: e.target.value }
                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Call to Action"
                  value={selectedElement.content?.callToAction || ''}
                  onChange={(e) => updateElement(selectedElement.id, {
                    content: { ...selectedElement.content, callToAction: e.target.value }
                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                  sx={{ mb: 2 }}
                />
              </>
            )}
            {selectedElement.type === 'BUTTON_IMAGE_CALLOUT' && (
              <>
                <TextField
                  fullWidth
                  label="Headline"
                  value={selectedElement.content?.headline || ''}
                  onChange={(e) => updateElement(selectedElement.id, {
                    content: { ...selectedElement.content, headline: e.target.value }
                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Image URL"
                  value={selectedElement.content?.image || ''}
                  onChange={(e) => updateElement(selectedElement.id, {
                    content: { ...selectedElement.content, image: e.target.value }
                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                  sx={{ mb: 2 }}
                />
    
                {/* File Upload Section for BUTTON_IMAGE_CALLOUT */}
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                    Or Upload Image
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const imageUrl = await handleImageUpload(file, selectedElement.id, true);
                          if (imageUrl) {
                            updateElement(selectedElement.id, {
                              content: { ...selectedElement.content, image: imageUrl }
                            }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                          }
                        }
                      }}
                      style={{ display: 'none' }}
                      id={`image-upload-callout-${selectedElement.id}`}
                    />
                    <label htmlFor={`image-upload-callout-${selectedElement.id}`}>
                      <Button
                        variant="outlined"
                        component="span"
                        startIcon={<UploadIcon />}
                        disabled={imageUploading && uploadingElementId === selectedElement.id}
                        sx={{ minWidth: 120 }}
                      >
                        {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Upload Image'}
                      </Button>
                    </label>
                    {imageUploading && uploadingElementId === selectedElement.id && (
                      <Box sx={{ ml: 1 }}>
                        <CircularProgress size={20} />
                      </Box>
                    )}
                  </Box>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                    Supported formats: JPG, PNG, GIF, WEBP (max 5MB) • Images stored locally
                  </Typography>
                </Box>
    
                <TextField
                  fullWidth
                  label="Badge Text"
                  value={selectedElement.content?.badge || ''}
                  onChange={(e) => updateElement(selectedElement.id, {
                    content: { ...selectedElement.content, badge: e.target.value }
                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                  sx={{ mb: 2 }}
                />
              </>
            )}
            {selectedElement.type === 'BUTTON_HEADLINE_PRODUCT_IMAGE' && (
              <>
                <TextField
                  fullWidth
                  label="Headline"
                  value={selectedElement.content?.headline || ''}
                  onChange={(e) => updateElement(selectedElement.id, {
                    content: { ...selectedElement.content, headline: e.target.value }
                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Product Image URL"
                  value={selectedElement.content?.productImage || ''}
                  onChange={(e) => updateElement(selectedElement.id, {
                    content: { ...selectedElement.content, productImage: e.target.value }
                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                  sx={{ mb: 2 }}
                />
    
                {/* File Upload Section for BUTTON_HEADLINE_PRODUCT_IMAGE */}
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                    Or Upload Product Image
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const imageUrl = await handleImageUpload(file, selectedElement.id, true);
                          if (imageUrl) {
                            updateElement(selectedElement.id, {
                              content: { ...selectedElement.content, productImage: imageUrl }
                            }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                          }
                        }
                      }}
                      style={{ display: 'none' }}
                      id={`product-image-upload-${selectedElement.id}`}
                    />
                    <label htmlFor={`product-image-upload-${selectedElement.id}`}>
                      <Button
                        variant="outlined"
                        component="span"
                        startIcon={<UploadIcon />}
                        disabled={imageUploading && uploadingElementId === selectedElement.id}
                        sx={{ minWidth: 120 }}
                      >
                        {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Upload Image'}
                      </Button>
                    </label>
                    {imageUploading && uploadingElementId === selectedElement.id && (
                      <Box sx={{ ml: 1 }}>
                        <CircularProgress size={20} />
                      </Box>
                    )}
                  </Box>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                    Supported formats: JPG, PNG, GIF, WEBP (max 5MB) • Images stored locally
                  </Typography>
                </Box>
    
                <TextField
                  fullWidth
                  multiline
                  rows={2}
                  label="Subheadline (Optional)"
                  value={selectedElement.content?.subheadline || ''}
                  onChange={(e) => updateElement(selectedElement.id, {
                    content: { ...selectedElement.content, subheadline: e.target.value }
                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                  sx={{ mb: 2 }}
                />
              </>
            )}
          </>
        )}
      {selectedElement.type === ELEMENT_TYPES.CUSTOM_LIST && (
        <>
          {selectedElement.rows.length > 1 && (
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <IconButton
                size="small"
                onClick={() => {
                  const iconToApply = selectedElement.rows[0].icon;
                  const newRows = selectedElement.rows.map(row => ({ ...row, icon: iconToApply }));
                  updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                }}
                title="Apply this icon to all items"
              >
                <span role="img" aria-label="apply to all">🔄</span>
              </IconButton>
              <Box sx={{ fontSize: '0.85rem', color: 'text.secondary', ml: 1 }}>
                Apply first icon to all items
              </Box>
            </Box>
          )}
          {selectedElement.rows.map((row, idx) => (
            <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Select
                value={row.icon}
                onChange={e => {
                  const newRows = [...selectedElement.rows];
                  newRows[idx].icon = e.target.value;
                  updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                }}
                sx={{ mr: 1, minWidth: 64 }}
              >
                <MenuItem value="check"><VerifiedIcon sx={{ color: '#b6ff3c' }} /></MenuItem>
                <MenuItem value="red-x">
                  <Box sx={{
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.5rem',
                    color: '#e53e3e',
                    fontWeight: 'bold'
                  }}>
                    ✗
                  </Box>
                </MenuItem>
                <MenuItem value="green-check-simple"><CheckMarkIcon sx={{ color: '#22c55e' }} /></MenuItem>
                <MenuItem value="red-x-simple"><CloseMarkIcon sx={{ color: '#ff3b30' }} /></MenuItem>
                <MenuItem value="pink-check">
                  <Box sx={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: '#ff9a9e',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1rem',
                    color: 'white',
                    fontWeight: 'bold'
                  }}>
                    ✓
                  </Box>
                </MenuItem>
                <MenuItem value="dark-check">
                  <Box sx={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '4px',
                    backgroundColor: '#2d3748',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1rem',
                    color: 'white',
                    fontWeight: 'bold'
                  }}>
                    ✓
                  </Box>
                </MenuItem>
                <MenuItem value="green-badge">
                  <Box sx={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: '#68d391',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.2rem',
                    color: 'white',
                    fontWeight: 'bold',
                    border: '2px solid #48bb78'
                  }}>
                    ✓
                  </Box>
                </MenuItem>
                <MenuItem value="star-badge">
                  <Box sx={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.2rem',
                    color: 'white',
                    fontWeight: 'bold',
                    border: '2px solid #5a67d8'
                  }}>
                    ⭐
                  </Box>
                </MenuItem>
                <MenuItem value="star"><StarIcon sx={{ color: '#ffe066' }} /></MenuItem>
                <MenuItem value="info"><InfoIcon sx={{ color: '#40c4ff' }} /></MenuItem>
                <MenuItem value="warning"><WarningIcon sx={{ color: '#ffb347' }} /></MenuItem>
                <MenuItem value="green-number">
                  <Box sx={{
                    width: 28, height: 28, borderRadius: '6px', background: '#22c55e',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: 'white', fontWeight: 'bold', fontSize: '1.2rem'
                  }}>
                    {idx + 1}
                  </Box>
                </MenuItem>
                <MenuItem value="circle-number">
                  <Box sx={{
                    width: 28, height: 28, borderRadius: '50%', border: '2px solid #22c55e',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#22c55e', fontWeight: 'bold', fontSize: '1.2rem', background: 'white'
                  }}>
                    {idx + 1}
                  </Box>
                </MenuItem>
              </Select>
              <TextField
                value={listItemTextValues[`${selectedElement.id}-${idx}`] !== undefined
                  ? listItemTextValues[`${selectedElement.id}-${idx}`]
                  : row.text}
                onChange={e => {
                  const key = `${selectedElement.id}-${idx}`;
                  setListItemTextValues(prev => ({
                    ...prev,
                    [key]: e.target.value
                  }));
                }}
                onBlur={() => {
                  const key = `${selectedElement.id}-${idx}`;
                  const newValue = listItemTextValues[key];
                  if (newValue !== undefined) {
                    const newRows = [...selectedElement.rows];
                    newRows[idx].text = newValue;
                    updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                    // Clear the temp value after saving
                    setListItemTextValues(prev => {
                      const updated = { ...prev };
                      delete updated[key];
                      return updated;
                    });
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    const key = `${selectedElement.id}-${idx}`;
                    const newValue = listItemTextValues[key];
                    if (newValue !== undefined) {
                      const newRows = [...selectedElement.rows];
                      newRows[idx].text = newValue;
                      updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                      // Clear the temp value after saving
                      setListItemTextValues(prev => {
                        const updated = { ...prev };
                        delete updated[key];
                        return updated;
                      });
                      e.target.blur();
                    }
                  }
                }}
                sx={{ flex: 1 }}
                autoFocus={false}
              />
              <IconButton onClick={() => {
                // Duplicate the current row and insert it below
                const newRows = [...selectedElement.rows];
                const duplicatedRow = { ...row, text: `${row.text} (copy)` };
                newRows.splice(idx + 1, 0, duplicatedRow);
                updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                setSelectedElement({ ...selectedElement, rows: newRows });
              }} title="Duplicate row">
                <DuplicateIcon />
              </IconButton>
              <IconButton onClick={() => {
                const newRows = selectedElement.rows.filter((_, i) => i !== idx);
                updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                setSelectedElement({ ...selectedElement, rows: newRows });
              }} title="Remove row"><DeleteIcon /></IconButton>
            </Box>
          ))}
          <Button onClick={() => {
            updateElement(selectedElement.id, { rows: [...selectedElement.rows, { icon: 'check', text: 'New item' }] });
          }} startIcon={<AddIcon />} sx={{ mb: 2 }}>Add Row</Button>
    
        </>
      )}
      {selectedElement.type === ELEMENT_TYPES.PROCESS_STEPS && (
        <>
          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold', mt: 3, mb: 2 }}>
            📋 Process Steps Content
          </Typography>
          {selectedElement.steps.map((step, idx) => (
            <Box key={idx} sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
              <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
                Step {step.number}
              </Typography>
    
              <TextField
                fullWidth
                label="Step Title"
                value={step.title}
                onChange={(e) => {
                  const newSteps = [...selectedElement.steps];
                  newSteps[idx].title = e.target.value;
                  updateElement(selectedElement.id, { steps: newSteps });
                }}
                sx={{ mb: 2 }}
              />
    
              <TextField
                fullWidth
                multiline
                rows={2}
                label="Step Description"
                value={step.description}
                onChange={(e) => {
                  const newSteps = [...selectedElement.steps];
                  newSteps[idx].description = e.target.value;
                  updateElement(selectedElement.id, { steps: newSteps });
                }}
                sx={{ mb: 2 }}
              />
    
              <TextField
                fullWidth
                label="Image URL"
                value={step.image}
                onChange={(e) => {
                  const newSteps = [...selectedElement.steps];
                  newSteps[idx].image = e.target.value;
                  updateElement(selectedElement.id, { steps: newSteps });
                }}
                sx={{ mb: 2 }}
              />
    
              {/* File Upload Section for Process Step Image */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Or Upload Step Image
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const imageUrl = await handleImageUpload(file, selectedElement.id, true);
                        if (imageUrl) {
                          const newSteps = [...selectedElement.steps];
                          newSteps[idx].image = imageUrl;
                          updateElement(selectedElement.id, { steps: newSteps });
                        }
                      }
                    }}
                    style={{ display: 'none' }}
                    id={`process-step-image-upload-${selectedElement.id}-${idx}`}
                  />
                  <label htmlFor={`process-step-image-upload-${selectedElement.id}-${idx}`}>
                    <Button
                      variant="outlined"
                      component="span"
                      startIcon={<UploadIcon />}
                      disabled={imageUploading && uploadingElementId === selectedElement.id}
                      sx={{ minWidth: 120 }}
                    >
                      {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Upload Image'}
                    </Button>
                  </label>
                  {imageUploading && uploadingElementId === selectedElement.id && (
                    <Box sx={{ ml: 1 }}>
                      <CircularProgress size={20} />
                    </Box>
                  )}
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                  Supported formats: JPG, PNG, GIF, WEBP (max 5MB) • Images stored locally
                </Typography>
              </Box>
    
              <TextField
                fullWidth
                label="Number Badge Color"
                value={step.numberColor || '#1976d2'}
                onChange={(e) => {
                  const newSteps = [...selectedElement.steps];
                  newSteps[idx].numberColor = e.target.value;
                  updateElement(selectedElement.id, { steps: newSteps });
                }}
                placeholder="#1976d2"
              />
            </Box>
          ))}
        </>
      )}
      {selectedElement.type === ELEMENT_TYPES.TEXT_WITH_RIGHT_IMAGE && (
        <>
          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold', mt: 3, mb: 2 }}>
            📝 Text + Right Image Content
          </Typography>
    
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Text Content"
            value={selectedElement.content.text}
            onChange={(e) => {
              updateElement(selectedElement.id, {
                content: { ...selectedElement.content, text: e.target.value }
              });
            }}
            sx={{ mb: 2 }}
          />
    
          <TextField
            fullWidth
            label="Image URL"
            value={selectedElement.content.image}
            onChange={(e) => {
              updateElement(selectedElement.id, {
                content: { ...selectedElement.content, image: e.target.value }
              });
            }}
            sx={{ mb: 2 }}
          />
    
          {/* File Upload Section for Text + Right Image */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="button" gutterBottom sx={{ fontWeight: 'bold' }}>
              Or Upload Image
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <input
                type="file"
                accept="image/*"
                onChange={async (e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const imageUrl = await handleImageUpload(file, selectedElement.id, true);
                    if (imageUrl) {
                      updateElement(selectedElement.id, {
                        content: { ...selectedElement.content, image: imageUrl }
                      });
                    }
                  }
                }}
                style={{ display: 'none' }}
                id={`text-right-image-upload-${selectedElement.id}`}
              />
              <label htmlFor={`text-right-image-upload-${selectedElement.id}`}>
                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<UploadIcon />}
                  disabled={imageUploading && uploadingElementId === selectedElement.id}
                  sx={{ minWidth: 120 }}
                >
                  {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Upload Image'}
                </Button>
              </label>
              {imageUploading && uploadingElementId === selectedElement.id && (
                <Box sx={{ ml: 1 }}>
                  <CircularProgress size={20} />
                </Box>
              )}
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
              Supported formats: JPG, PNG, GIF, WEBP (max 5MB) • Images stored locally
            </Typography>
          </Box>
        </>
      )}
    
    
    
      {selectedElement.type === ELEMENT_TYPES.LEFT_IMAGE_TEXT && (
        <>
          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold', mt: 3, mb: 2 }}>
            🖼️ Left Image + Text Content
          </Typography>
    
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Text Content"
            value={selectedElement.content.text}
            onChange={(e) => {
              updateElement(selectedElement.id, {
                content: { ...selectedElement.content, text: e.target.value }
              });
            }}
            sx={{ mb: 2 }}
          />
    
          <TextField
            fullWidth
            label="Image URL"
            value={selectedElement.content.image}
            onChange={(e) => {
              updateElement(selectedElement.id, {
                content: { ...selectedElement.content, image: e.target.value }
              });
            }}
            sx={{ mb: 2 }}
          />
    
          {/* File Upload Section for Left Image + Text */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Or Upload Image
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <input
                type="file"
                accept="image/*"
                onChange={async (e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const imageUrl = await handleImageUpload(file, selectedElement.id, true);
                    if (imageUrl) {
                      updateElement(selectedElement.id, {
                        content: { ...selectedElement.content, image: imageUrl }
                      });
                    }
                  }
                }}
                style={{ display: 'none' }}
                id={`left-image-text-upload-${selectedElement.id}`}
              />
              <label htmlFor={`left-image-text-upload-${selectedElement.id}`}>
                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<UploadIcon />}
                  disabled={imageUploading && uploadingElementId === selectedElement.id}
                  sx={{ minWidth: 120 }}
                >
                  {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Upload Image'}
                </Button>
              </label>
              {imageUploading && uploadingElementId === selectedElement.id && (
                <Box sx={{ ml: 1 }}>
                  <CircularProgress size={20} />
                </Box>
              )}
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
              Supported formats: JPG, PNG, GIF, WEBP (max 5MB) • Images stored locally
            </Typography>
          </Box>
    
          {/* Image Size Control */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Image Size
            </Typography>
            <Box sx={{ px: 2 }}>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                Size: {selectedElement.imageSize || 120}px
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="caption">60</Typography>
                <Box sx={{ flex: 1 }}>
                  <input
                    type="range"
                    min="60"
                    max="300"
                    value={selectedElement.imageSize || 120}
                    onChange={(e) => {
                      const newSize = parseInt(e.target.value);
                      // Debounce updates to prevent ResizeObserver errors
                      clearTimeout(window.imageSizeTimeout);
                      window.imageSizeTimeout = setTimeout(() => {
                        updateElement(selectedElement.id, {
                          imageSize: newSize
                        });
                      }, 50);
                    }}
                    style={{ width: '100%' }}
                  />
                </Box>
                <Typography variant="caption">300</Typography>
              </Box>
            </Box>
          </Box>
    
          {/* Spacing Control */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Spacing Between Image and Text
            </Typography>
            <Box sx={{ px: 2 }}>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                Gap: {selectedElement.spacing || 20}px
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="caption">0</Typography>
                <Box sx={{ flex: 1 }}>
                  <input
                    type="range"
                    min="0"
                    max="80"
                    value={selectedElement.spacing || 20}
                    onChange={(e) => {
                      const newSpacing = parseInt(e.target.value);
                      // Debounce updates to prevent ResizeObserver errors
                      clearTimeout(window.spacingTimeout);
                      window.spacingTimeout = setTimeout(() => {
                        updateElement(selectedElement.id, {
                          spacing: newSpacing
                        });
                      }, 50);
                    }}
                    style={{ width: '100%' }}
                  />
                </Box>
                <Typography variant="caption">80</Typography>
              </Box>
            </Box>
          </Box>
    
          {/* Image Alignment Control */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Image Vertical Alignment
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
              Choose how the image aligns with the text content
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
              {[
                { value: 'top', label: 'Top', icon: '⬆️' },
                { value: 'center', label: 'Center', icon: '↔️' },
                { value: 'bottom', label: 'Bottom', icon: '⬇️' }
              ].map((option) => (
                <Button
                  key={option.value}
                  variant={selectedElement.imageAlignment === option.value ? 'contained' : 'outlined'}
                  size="small"
                  onClick={() => {
                    updateElement(selectedElement.id, {
                      imageAlignment: option.value
                    }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                  }}
                  sx={{
                    minWidth: 70,
                    backgroundColor: selectedElement.imageAlignment === option.value ? '#1976d2' : '#ffffff',
                    color: selectedElement.imageAlignment === option.value ? '#ffffff' : '#1976d2',
                    border: `1px solid #1976d2`,
                    '&:hover': {
                      backgroundColor: selectedElement.imageAlignment === option.value ? '#1565c0' : '#e3f2fd'
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                    <Typography variant="caption" sx={{ fontSize: '10px' }}>
                      {option.icon}
                    </Typography>
                    <Typography variant="caption" sx={{ fontSize: '10px' }}>
                      {option.label}
                    </Typography>
                  </Box>
                </Button>
              ))}
            </Box>
          </Box>
    
    
        </>
      )}
    </Box>
  );
};

export default ContentTab;
